/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the outgoing PlannerInitialConsultationCheckView response data.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerInitialConsultationCheckResponse { 
    initialConsultationAlreadyBooked: boolean;
}
export const PlannerInitialConsultationCheckResponse_initialConsultationAlreadyBooked_Validators: ValidatorFn[] =
    [  Validators.required, ];


